import SectionHeader, { SectionHeaderTag, SectionHeaderProps, SectionHeaderSize } from './SectionHeader';

export default function PageHeader(props: Omit<SectionHeaderProps, 'tag'>) {
  return <SectionHeader tag={SectionHeaderTag.H1} {...props} />;
}
